"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentPlan = exports.ScheduledPayment = void 0;
const Money_1 = require("../../../money/domain/Money");
const infrastructure_1 = require("../../../infrastructure");
const validator_1 = require("@leavy/validator");
class ScheduledPayment extends infrastructure_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    toPlain() {
        return { ...this };
    }
}
__decorate([
    (0, validator_1.Type)(() => Money_1.MoneyObject),
    __metadata("design:type", Object)
], ScheduledPayment.prototype, "amountDue", void 0);
exports.ScheduledPayment = ScheduledPayment;
class PaymentPlan extends infrastructure_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    toPlain() {
        return { ...this };
    }
}
__decorate([
    (0, validator_1.Type)(() => Money_1.MoneyObject),
    __metadata("design:type", Object)
], PaymentPlan.prototype, "baseRevenue", void 0);
__decorate([
    (0, validator_1.Type)(() => Money_1.MoneyObject),
    __metadata("design:type", Object)
], PaymentPlan.prototype, "adjustedRevenue", void 0);
__decorate([
    (0, validator_1.Type)(() => ScheduledPayment),
    __metadata("design:type", Array)
], PaymentPlan.prototype, "schedule", void 0);
exports.PaymentPlan = PaymentPlan;
//# sourceMappingURL=PaymentPlan.js.map